import { IState } from '../../../../../../store/types';
import { connect } from 'react-redux';
import { PhraseTranslationSettings } from '../components/PhraseTranslationSettings';
import {
	IPhraseTranslationSettingsEvents,
	IPhraseTranslationSettingsFields
} from '../components/types';
import { getAuthUserTranslateLangs, isShowTranslations } from '../../../../../../store/general/selectors';
import { PhraseTranslationSettingsEvents } from './events';
import { getActiveGroupNativeLanguage } from '../../../../../../store/models/selectors';


const mapStateToProps = (
	dispatch: any
) => {
	return (
		state: IState
	): IPhraseTranslationSettingsFields => {
		const translateLangs = getAuthUserTranslateLangs(state)
		let nativeGroupLang = getActiveGroupNativeLanguage(state);
		const translateNativeCodeExist = translateLangs.some(l => l.code === nativeGroupLang?.code);
		const nativeGroupLangCode = !translateNativeCodeExist && nativeGroupLang ? nativeGroupLang.code : '';
		return {
			showTranslations: !!isShowTranslations(state),
			translateLangs,
			nativeGroupLangCode
		}
	};
}

const mapDispatchToProps = (
	dispatch: any
): IPhraseTranslationSettingsEvents => ({
	onSort: (langCodes) => dispatch(PhraseTranslationSettingsEvents.onSort(langCodes)),
	onToggleShowTranslations: () => dispatch(PhraseTranslationSettingsEvents.onToggleShowTranslations()),
}
);

export const PhraseTranslationSettingsHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(PhraseTranslationSettings) as any;

PhraseTranslationSettingsHOC.displayName = 'PhraseTranslationSettingsHOC';
